import { skillData } from "../../data";

import profilePic from "../images/final.png";

const About = ({ theme }) => {
  const newTheme = `${theme} d-flex flex-column min-vh-100 justify-content-center`;
  const spanStyle = {
    fontWeight:'400px',
    fontStyle:'normal',
    textDecoration:'none',
    color:'#000'
  }

  return (
    <section id="about" className={newTheme}>
      <div className="container text-center">
        <h2>About</h2>
        <hr />
        {/* <div className="row row-cols-3">
          {skillData.map((skills) => {
            return (
              <figure className="col" key={skills.id}>
                {skills.skill}
                <figcaption>{skills.name}</figcaption>
              </figure>
            );
          })}
        </div> */}
        <div className="d-flex">

        <div className="container text-left">
            <img src={profilePic} style={{width: '23%'}} className="img-fluid rounded float-left mr-3" alt="James McGlone" />

            <p>
              I'm a passionate developer with a lifelong interest in web and software development.
              I have proven skills in full stack development right through from building front-end UI/UX, beautiful back-ends, optimizing database usage, and designing and implementing cost effective and reliable hosting solutions. 
            </p>
            <p>
            I enjoy pushing myself to continually improve and expand my understanding of technologies across different stacks. 
            I get a kick out of creating and maintaining well oiled machines.
            </p>
            <p>
              My comfort zone is working with modern javascript frameworks (React and Vue), and NodeJS or Laravel PHP back-ends on Linux machines.
              That said, I love to break out of my comfort zone and have an interest in everything computer science related and am happiest when I'm learning something new.
            </p>
            <p>
              Recognised as a productive, creative and resourceful problem solver with a strong ability to communicate effectively with clients and colleagues.
              When I'm not programming I'm usually working on projects in lighting, electronics, film making and synthesizers, or rehearsing for the occasional gig.
            </p>
            
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;
